export default "__VITE_ASSET__7177e530__"